import * as React from 'react';
import { FilterUserState, SpendingReportState, SummaryTableChart } from '../../../interface/MyInterfaces';
import { Summary } from './Summary';
import { EmployeeTable } from './EmployeeTable';
import { EmployeeAgencyTable } from './EmployeeAgencyTable';
import { ExpenditureTable } from './ExpenditureTable';
import { InStateExpenditureBoxPlot } from './InStateExpenditureBoxPlot';
import { formatFiscalYear, getYearRangeLabel } from '../../Common/Helpers';
import renderHTML from 'react-render-html';
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';


class BenchmarkingTab extends React.Component<FilterUserState & SpendingReportState, {}> {
    constructor(props) {
        super(props);
    }

    getOverview() {
        if (this.props.UserState !== undefined && this.props.UserState.username !== undefined && this.props.UserState.username !== "" && this.props.UserState.report_display_id !== undefined && this.props.UserState.report_display_id !== "") {
            let logoUni;
            try {
                logoUni = require(`../../../images/univ_logos/${this.props.UserState.report_display_id}.png`);
            }
            catch (err) {

            }
            return (
                <div>
                    <div className="row">
                        <div className="col-md-9">
                            <h1>{this.props.SpendingReport_Tab3 && this.props.SpendingReport_Tab3.header}</h1>
                            {this.props.UserState.report_display_id == "99007319" && <h2><b style={{ color: "red" }}>Synthetic data for demonstration purposes only</b></h2>}
                            <h3>{this.props.SpendingReport_Tab3 && this.props.SpendingReport_Tab3.sub_header}</h3>
                        </div>
                        <div className="col-md-3">
                            {logoUni &&
                                <img height='80px' src={String(logoUni)} alt='Logo'></img>
                            }
                        </div>
                    </div>
                </div>
            );
        } else {
            return <i className="fa fa-spinner"></i>;
        }
    }


    getMappedPercent() {
        if (this.props.SpendingReport_Tab3 !== undefined) {
            return this.props.SpendingReport_Tab3.footer_text;
        }
        return <i className="fa fa-spinner"></i>;
    }

    renderBenchmarkingByOcc = (report_display_id) => {
        if (report_display_id == '14977' || ((this.props.SpendingEmployeeChart == null || this.props.SpendingEmployeeChart.length == 0) && (this.props.SpendingEmployeeAgencyChart == null || this.props.SpendingEmployeeAgencyChart.length == 0))) {
            return <div className="chartcontainer">
                <img src={require('../../../images/JHU_benchmark_mask.jpg')} alt="JHU_benchmark_employee_tables" />
            </div>
        }
        return <div className='row'>
            {this.props.SpendingEmployeeChart && this.props.SpendingEmployeeChart.length>0 ?
           <div><div className="col-md-6">
                <p>This table displays:</p>
                <ol>
                    <li>The percentage of {this.props.SpendingReport_Tab3 && this.props.SpendingReport_Tab3.university}'s unique employees paid on research grants in a given occupational category, calculated from the university's employee data file, with the standard deviation from the mean.</li><br />
                    <li>The percentage of unique employees paid on research grants across {this.props.FilterState && this.props.FilterState.bench_schools.length} other IRIS member universities, broken out by occupational category, with the standard deviation from the mean.</li><br />
                    <li>Numbers in orange text indicate that university's employee percentage diverges from the mean by 1 standard deviation. Red text indicates that university's employee percentage diverges from the mean by 2 or more standard deviations.</li>
                </ol>
            </div>
            <div className="col-md-6">
              <EmployeeTable SpendingEmployeeTable={this.props.SpendingEmployeeTable} />
                    </div></div> :
                <div className="chartcontainer">
                    <img src={require('../../../images/benchmark_mask2.png')} alt="JHU_benchmark_employee_tables" />
                </div>
            }{
                this.props.SpendingEmployeeAgencyChart && this.props.SpendingEmployeeAgencyChart.length > 0 ?
                    <div className='row benchmarking_big_table'><div className="col-md-12">
                    <EmployeeAgencyTable
                        SpendingEmployeeAgencyTable={this.props.SpendingEmployeeAgencyTable} />
                    <p>This table displays:</p>
                    <ol>
                        <li>The percentage of your university's unique employees paid on research grants in a given occupational category, broken out by the funding agency.</li>
                        <li>The mean percentage and standard deviation of unique employees in a given occupational classification across {this.props.FilterState && this.props.FilterState.bench_schools.length} other IRIS member universities, broken out by the federal funding agency.</li>
                        <li>Numbers in orange text indicate that {this.props.SpendingReport_Tab3 && this.props.SpendingReport_Tab3.university}'s employee percentage diverges from the mean by 1 standard deviation. Red text indicates that university's employee percentage diverges from the mean by 2 or more standard deviations.</li>
                    </ol>
                    <p>All values are calculated from {this.props.SpendingReport_Tab3 && this.props.SpendingReport_Tab3.bench_year} data submitted by {this.props.SpendingReport_Tab3 && this.props.SpendingReport_Tab3.university}.</p>
                    <ul>    <li>The 8 funding agencies listed are those associated with the greatest number of {this.props.SpendingReport_Tab3 && this.props.SpendingReport_Tab3.university} employees for {this.props.FilterState && this.props.FilterState.start_year == this.props.FilterState.end_year ? this.props.FilterState.start_year : `${this.props.FilterState.start_year} – ${this.props.FilterState.end_year}`}. Not all employee data are captured in this summary table.</li>
                        <li>The occupational categories were mapped to {this.props.SpendingReport_Tab3 && this.props.SpendingReport_Tab3.university}'s original HR titles, as described in the online technical documentation.</li>
                    </ul>
                </div></div>:
                    <div className="chartcontainer">
                        <img src={require('../../../images/benchmark_mask2.png')} alt="JHU_benchmark_employee_tables" />
                </div>
            }
        </div>
    }


    public render() {
        return <div className='tabcontents container-fluid'>
            {this.getOverview()}
            <div className="row row__header">
                <p>
                    This report is designed to summarize the latest {this.props.SpendingReport_Tab3 && this.props.SpendingReport_Tab3.university} UMETRICS data submission and benchmark university employee and vendor data with {this.props.FilterState && this.props.FilterState.bench_schools.length} other IRIS member universities.
			    </p>
                <p>
                    The IRIS member universities included in the aggregate benchmarks in this report are {this.props.SpendingReport_Tab3 && this.props.SpendingReport_Tab3.bench_schools !== undefined && this.props.SpendingReport_Tab3.bench_schools.map(x => x.label.replace('amp;', '')).join(", ")}.
                 </p>
            </div>
            <div className='row'>
                <div className="col-md-12">
                    <h4>
                        Summary for all {this.props.SpendingReport_Tab3 && this.props.SpendingReport_Tab3.university}'s UMETRICS employee and expenditure data files submitted to IRIS
			        </h4>
                    <Summary start_year={this.props.FilterState.start_year} end_year={this.props.FilterState.end_year} SpendingSummaryTable={this.props.SpendingSummaryTable} />
                    <h4>
                        Benchmarking Employees by Occupational Category - <span className="capitalize">{this.props.SpendingReport_Tab3 && this.props.SpendingReport_Tab3.bench_year}</span>
                    </h4>
                </div>
            </div>
            {
                //JHU
                this.renderBenchmarkingByOcc(this.props.UserState.report_display_id)
            }
            <div className='row'>
                <div className="col-md-6">
                    <h4>Benchmarking Vendor Expenditures - <span className="capitalize">{this.props.SpendingReport_Tab3 && this.props.SpendingReport_Tab3.bench_year}*</span></h4>
                    <ExpenditureTable SpendingExpenditureTable={this.props.SpendingExpenditureTable} SpendingExpenditureTable2={this.props.SpendingExpenditureTable2} />
                </div>
                <div className="col-md-6">
                    <h4>In-State Vendor Expenditures Benchmarked*</h4>
                    <InStateExpenditureBoxPlot FilterState={this.props.FilterState} SpendingExpenditureTable2={this.props.SpendingExpenditureTable2} SpendingInStateExpenditureBoxPlot={this.props.SpendingInStateExpenditureBoxPlot} />
                    <p>
                        Total in-state expenditures in {this.props.SpendingReport_Tab3 && this.props.SpendingReport_Tab3.university}'s {this.props.SpendingReport_Tab3 && this.props.SpendingReport_Tab3.bench_year} vendor data are plotted on a box plot display of total in-state vendor expenditures from {this.props.FilterState.bench_schools.length} other IRIS member universities.
			        </p>
                </div>
            </div>
            <div className='row'>
                <div className="bottomtext col-md-12">
                    *Generally, about {this.getMappedPercent()}% of research expenditures can be matched to location information with available data and methodology.
                </div>
            </div>
        </div>
    }
}

export default withUserActionTracker(BenchmarkingTab, "Spending Report", "viewed UMETRICS Benchmarking Tab");